module.exports = __webpack_public_path__ + "img/wei.8f98b51c.png";